"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _heading = _interopRequireDefault(require("../heading"));

var _pill = _interopRequireDefault(require("../pill"));

var _index = _interopRequireDefault(require("./index.scss"));

var FiltersLarge = function FiltersLarge(_ref) {
  var children = _ref.children,
      countDisplay = _ref.countDisplay,
      idPrefix = _ref.idPrefix;
  return _react["default"].createElement("div", {
    className: _index["default"].filtersContainer
  }, _react["default"].createElement(_heading["default"], {
    type: "megasmalldivider",
    className: _index["default"].filtersHeading,
    id: "filter-heading",
    underline: false,
    inlineStyles: undefined
  }, "Filters"), countDisplay && _react["default"].createElement("div", {
    className: _index["default"].countWrapper
  }, _react["default"].createElement(_pill["default"], {
    className: _index["default"].count,
    type: "secondary",
    dataTestId: idPrefix && "".concat(idPrefix, "-items-count-large")
  }, countDisplay)), children);
};

var _default = FiltersLarge;
exports["default"] = _default;